export default "__VITE_ASSET__Dp6r5Fpf__"